export default function handlePardotFormSubmit(formEl: HTMLFormElement) {
    const leadformEl = formEl.closest<HTMLElement>('.leadform');
    const loadingIndicatorEl = leadformEl?.querySelector<HTMLElement>(
        '[data-loader=ls-loader]'
    );
    if (loadingIndicatorEl) {
        loadingIndicatorEl.classList.add('tw:block');
        formEl.classList.add('tw:hidden');
        formEl.classList.remove('tw:block');
    }

    formEl.submit();
}
